import { appRoutes } from 'config';
import { User } from 'models/User';
import Link from 'next/link';
import {
  openBoxSidebar,
  openSettingsSidebar,
} from 'xstate/actors/SidebarActor';
import UserButton from '../../elements/UserButton';
import LeftButton from './Button/LeftButton';
import MenuButton from './Button/MenuButton';
import HeaderSearch from './HeaderSearch';
import Logotype from 'assets/icons/logotype.svg';

type HeaderVariant = 'default' | 'dashboard' | 'settings';

type Props = {
  variant?: HeaderVariant;
  user?: User;
  isProAccount?: boolean;
};

// TODO: https://mindfeed.atlassian.net/browse/SP-552
const Header = ({ variant, user, isProAccount = false }: Props) => {
  return (
    // In the flow on mobile so it scrolls away; pinned at sm+, which the rails
    // and switcher bar anchor to.
    <nav className="bg-mf-blue-800 relative sm:fixed sm:top-0 w-full z-auto sm:z-20">
      {/* Wherever the rail shows (sm and up), the left padding is the rail's
          width (w-18, then w-20 from md) plus 16px, so the logo lines up
          with the content's left edge ("Memory Boxes" on large screens).
          On mobile there is no rail and the logo stays centred. */}
      <div className="px-4 sm:pl-22 md:pl-24 lg:pr-6">
        <div className="relative flex items-center h-16">
          {/* Mobile - Left Toggle Menu Button */}
          {/* Dashboard shows the box icon; settings keeps the hamburger. */}
          {variant === 'dashboard' && (
            <LeftButton className="sm:hidden" onClick={openBoxSidebar} />
          )}

          {variant === 'settings' && (
            <MenuButton className="sm:hidden" onClick={openSettingsSidebar} />
          )}

          {/* The logo side and the user side get the same flexible share, so
              the search between them sits in the true centre of the bar and
              doesn't move when the user's name arrives or changes length. */}
          <div className="flex flex-1 basis-0 items-center">
            {/* Logo. Auto margins centre it on mobile (pure flexbox); on
                desktop it returns to the normal left-aligned flow. */}
            <Link
              href={appRoutes.MEMORY_SPACE}
              className="flex items-center mx-auto sm:mx-0"
            >
              <Logotype
                className="block h-4 w-auto text-white"
                role="img"
                aria-label="MindFeed"
              />
            </Link>
          </div>

          {/* Centre search box — dashboard only, desktop only. */}
          {variant === 'dashboard' && <HeaderSearch />}

          <div className="hidden sm:flex sm:flex-1 sm:basis-0 sm:justify-end sm:items-center">
            {/* Avatar only up to 4xl; full name/username/chevron beyond it. */}
            <div className="2xl:hidden">
              <UserButton
                user={user}
                isPro={isProAccount}
                variant="condensed"
                tone="dark"
              />
            </div>
            <div className="hidden 2xl:block">
              <UserButton
                user={user}
                isPro={isProAccount}
                variant="default"
                tone="dark"
              />
            </div>
          </div>

          {/* Spacer to keep the mobile logo centred against the left button. */}
          {(variant === 'dashboard' || variant === 'settings') && (
            <span className="flex w-[36px] sm:hidden" />
          )}
        </div>
      </div>
    </nav>
  );
};

export default Header;
